import Vue from 'vue';
import Vuex from 'vuex';
/*
*****************************
start general camp section
*****************************
*/
import { notifications } from './notifications.module';
import { table } from './table.module';


import { auth } from '@/modules/auth/store/auth.module';

/*
*****************************
start form section
*****************************
*/
import { form } from '@/modules/form/store/form.module';
/*
*****************************
start user section
*****************************
*/

import { type } from '@/modules/users/store/type.module';
import { user } from '@/modules/users/store/user.module';


import { complaints } from '@/modules/complaints/store/complaints.module';
import application from '@/modules/applications/store/application.module';
import regulatory_level from '@/modules/violations/store/regulatory_level.module';
import regulatory_damage from '@/modules/violations/store/regulatory_damage.module';
import regulatory_form from '@/modules/violations/store/regulatory_form.module';
import regulatory_order from '@/modules/violations/store/regulatory_order.module';
import { risk_level } from '@/modules/applications/store/risk_level.module';
import readiness from '@/modules/readiness/store/readiness.module';
import damage_readiness from '@/modules/readiness/store/damage.module';
import readiness_street from '@/modules/readiness/store/street.module';
Vue.use(Vuex);
// Vue.use(router);
export default new Vuex.Store({
    state: () => ({
        collection: '',
        name_function: '',
        id: '',
        parent_page: '',
        url: null,
        card: {},
        action_service: true,
    }),
    mutations: {
        SET_ACTION_SERVICE(state, data) {
            state.action_service = data
        },
        SET_COLLECTION(state, data) {
            state.collection = data
        },
        SET_URL(state, data) {
            state.url = data
        },
        SET_FUNCTION(state, data) {
            state.name_function = data;
        },
        SET_ID(state, data) {
            state.id = data;
        },
        SET_CARD(state, data) {
            state.card = data;
        },
        SET_CARD_LOADING(state, data) {
            state.card.loading = data;
        },
        SET_PARENT_PAGE(state, data) {
            state.parent_page = data;
        },
        // SET_FORM_DATA(state,data){
        //     state.form_data = data
        // },
    },
    actions: {
        ResetData({ state, rootState }) {
            rootState.table.btn_table = [];
            rootState.table.items = [];
            rootState.table.data_extend = {};
            rootState.table.data_expand = {};
            rootState.table.headers = [];
            rootState.table.btns = [];
            rootState.table.chack_permission = 'd-none';
            rootState.table.pagination = false;
            rootState.table.paginate = {
                page: 1,
                itemsPerPage: 0,
                total: 0,
                row_pre_page: false
            };
            rootState.table.select_view = false
            rootState.table.bulk_selected = [],
                state.url = null
            state.name_function = ''
            state.collection = ''
            state.id = '',
                state.parent_page = '',

                // form
                rootState.form.filters = [];
            rootState.form.formData = null;
            rootState.form.form_data = {};
            rootState.form.style_form = [];
            rootState.form.action = '';
            rootState.form.notify = {
                color: null,
                visible: false,
                msg: '',
                note: ''
            };
            rootState.form.modal = {};
            rootState.form.loader = false;
            rootState.form.dialog = false;
            rootState.form.stepper = {}
            rootState.form.filter_year = false;
            rootState.form.filter_year_id = null;
            return true;
        },
    },
    modules: {

        auth, table, form, user, notifications,
        type, complaints, application,
        regulatory_level, regulatory_damage, regulatory_form, regulatory_order
        , risk_level,
        readiness,
        damage_readiness,
        readiness_street

    }
});